import { render, staticRenderFns } from "./FullWidthTextFieldWithCharacterCounter.vue?vue&type=template&id=72810b2c&"
import script from "./FullWidthTextFieldWithCharacterCounter.vue?vue&type=script&lang=js&"
export * from "./FullWidthTextFieldWithCharacterCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports